import React, { CSSProperties, ReactNode } from "react";
import { customEvent } from "../../utils/customEvent";
import { CommonEventProps } from "../../types";

export interface ButtonProps {
  children: ReactNode;
  event?: CommonEventProps;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  style?: CSSProperties;
}

export function Button({
  children,
  event,
  className,
  disabled,
  onClick,
  style,
}: ButtonProps) {
  const handleButtonClick = () => {
    if (event) customEvent(event);
    if (onClick) onClick();
  };

  return (
    <button
      className={className}
      onClick={handleButtonClick}
      style={style}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
